.box :global tbody td {
  position: relative;
}
